export default __webpack_public_path__ + "static/media/sim-paris.b746eaec.jpg";